'use client';

import { AppWindowMac, BrainCircuit, Database, Folder, InfoIcon, Menu } from 'lucide-react';
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from 'shared/ui/sidebar';
import { Link, usePathname } from 'shared/lib/i18n';
import { HelperNav } from 'widgets/main-sidebar/ui/helper-nav';
import { type LucideIcon } from 'lucide-react';
import * as m from '@paraglide/messages';
import { useMemo } from 'react';
import { DOCS_DOMAIN } from 'shared/lib/util';

// Menu items.

export function AppSidebar() {
  const items: {
    title: string;
    url: string;
    icon: LucideIcon;
  }[] = useMemo(() => [{
    title: m.main_sidebar_apps(),
    url: '/projects/applications',
    icon: AppWindowMac
  }, {
    title: m.main_sidebar_postgres(),
    url: '/projects/dbs',
    icon: Database
  }, {
    title: m.main_sidebar_preconfigured(),
    url: '/projects/pre-configured',
    icon: Folder
  }, {
    title: `${m.main_sidebar_llm()} (Preview)`,
    url: '/projects/llm',
    icon: BrainCircuit
  }], []);
  const helpers = useMemo(() => [{
    title: m.main_sidebar_docs(),
    url: `${DOCS_DOMAIN}/index.html#`,
    icon: InfoIcon
  }], []);
  const {
    toggleSidebar,
    setOpenMobile
  } = useSidebar();
  const pathname = usePathname();
  return <Sidebar collapsible="icon" variant="sidebar" className=" relative h-full" data-sentry-element="Sidebar" data-sentry-component="AppSidebar" data-sentry-source-file="app-sidebar.tsx">
      <SidebarContent data-sentry-element="SidebarContent" data-sentry-source-file="app-sidebar.tsx">
        <SidebarHeader className="p-0 mt-2" data-sentry-element="SidebarHeader" data-sentry-source-file="app-sidebar.tsx">
          <SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="app-sidebar.tsx">
            <SidebarMenuItem className="z-10 px-1.5 [[data-state=expanded]_&>*>*>a]:w-fit " data-sentry-element="SidebarMenuItem" data-sentry-source-file="app-sidebar.tsx">
              <div className="bg-background flex items-center space-x-2 rounded-lg">
                <SidebarMenuButton onClick={toggleSidebar} data-sentry-element="SidebarMenuButton" data-sentry-source-file="app-sidebar.tsx">
                  <Menu className="text-primary" data-sentry-element="Menu" data-sentry-source-file="app-sidebar.tsx" />
                </SidebarMenuButton>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <Link href="/projects" className="truncate font-semibold hover:underline" onClick={() => setOpenMobile(false)} data-sentry-element="Link" data-sentry-source-file="app-sidebar.tsx">
                    {m.main_sidebar_title()}
                  </Link>
                </div>
              </div>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarHeader>
        <SidebarGroup data-sentry-element="SidebarGroup" data-sentry-source-file="app-sidebar.tsx">
          <SidebarGroupContent data-sentry-element="SidebarGroupContent" data-sentry-source-file="app-sidebar.tsx">
            <SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="app-sidebar.tsx">
              {items.map(item => <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={pathname.startsWith(item.url)}>
                    <Link href={item.url} onClick={() => setOpenMobile(false)}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>)}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <HelperNav items={helpers} className="mt-auto mb-2" data-sentry-element="HelperNav" data-sentry-source-file="app-sidebar.tsx" />
      </SidebarContent>
    </Sidebar>;
}